// extracted by mini-css-extract-plugin
export var layout = "style_layout__k+lxR";
export var main = "style_main__ScI9V";
export var rotate = "style_rotate__lxAF4";
export var dotty = "style_dotty__jMDJh";